import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Codification } from './../../model/Codification';

@Component({
  selector: 'digit',
  templateUrl: './digit.component.html',
  styleUrls: ['./digit.component.less']
})
export class DigitComponent implements OnInit {

  constructor() { }

  @Input()
  public size: number = 100 / 6;

  @Input()
  public state: string = "";

  @Input()
  public class: string = "";

  @Input()
  public digit: number;

  @Input()
  public selected: boolean = false;

  @Input()
  public codification: Codification = new Codification("numbers", null, 10);

  @Output()
  public onDigitClick: EventEmitter<number> = new EventEmitter<number>();

  @Input()
  public duplicate: boolean = false;

  public digitClick(e, digit: number) {
    e.stopPropagation();
    this.onDigitClick.emit(digit)

  }

  public get isNumber() { return this.codification?.type == "numbers" }

  public get digitClass() {
    return this.codification?.type + " " + this.class;
  }
  ngOnInit(): void {
  }

}
